import { useState } from "react";
import { ChevronDown } from "lucide-react";

const CampaignAccessSelect = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);

  const options = [
    {
      value: "INVITE_ONLY",
      title: "Invite Only",
      description: "Only users with invited domains can access",
    },
    // {
    //   value: "Join Code",
    //   title: "Join Code",
    //   description: "Users can access by entering a shared code",
    // },
  ];

  const selectedOption = options.find((option) => option.value === value);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex h-11 w-full items-center justify-between rounded-md border border-[#14708A] bg-[#151515] px-4 text-left text-sm text-neutral-100 outline-none"
      >
        <span className={selectedOption ? "text-neutral-100" : "text-neutral-100/50"}>
          {selectedOption?.title || "Select Access Type"}
        </span>

        <ChevronDown className="h-5 w-5 text-[#67D8FF]" />
      </button>

      {open && (
        <div className="absolute z-30 mt-1 w-full overflow-hidden rounded-md border border-[#14708A] bg-brand-100 shadow-lg">
          {options.map((option) => {
            const isSelected = value === option.value;

            return (
              <button
                key={option.value}
                type="button"
                onClick={() => {
                  onChange(option.value);
                  setOpen(false);
                }}
                className="flex w-full items-center gap-3 border-b border-[#1D3342] px-4 py-3 text-left last:border-b-0 hover:bg-[#071827]"
              >
                <span
                  className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${
                    isSelected ? "border-brand-15" : "border-white/40"
                  }`}
                >
                  {isSelected && (
                    <span className="h-2 w-2 rounded-full bg-brand-15" />
                  )}
                </span>

                <span className="text-sm font-bold text-neutral-100">
                  {option.title}
                </span>

                <span className="text-xs text-neutral-100/50">
                  {option.description}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CampaignAccessSelect;
